import { render, staticRenderFns } from "./BuddhismTablets.vue?vue&type=template&id=e3fb2890&scoped=true"
import script from "./BuddhismTablets.vue?vue&type=script&lang=js"
export * from "./BuddhismTablets.vue?vue&type=script&lang=js"
import style0 from "./BuddhismTablets.vue?vue&type=style&index=0&id=e3fb2890&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3fb2890",
  null
  
)

export default component.exports